import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Form from 'rc-field-form'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { message } from 'antd'
import { Password, Input } from 'app/login/components'
import { Button, FormItem } from 'components'
import styles from './index.module.less'

const selector = ({ login, loading }) => ({
  limit: login.limit,
  loading: ['login/onGeetest', 'login/login'].some(
    item => loading.effects[item]
  ),
})
export default function Index() {
  const dispatch = useDispatch()
  const { limit, loading } = useSelector(selector, shallowEqual)

  const [clickTime, setClickTime] = useState(true)
  const history = useHistory()
  const [form] = Form.useForm()

  const __dev__ = process.env.NODE_ENV === 'development'
  const initialValues = {
    workId: __dev__ ? 'YGADMIN' : '',
    password: __dev__ ? 'qwert123456' : '',
  }

  const onFinish = values => {
    if (!clickTime) return message.error('操作频繁，请稍后再试')
    setClickTime(false)
    setTimeout(() => setClickTime(true), 2000)

    dispatch({
      type: 'login/login',
      payload: {
        ...values,
        limit,
        loginType: 'id',
        history,
      },
    })
  }

  return (
    <Form
      form={form}
      className={styles.idLogin}
      initialValues={initialValues}
      onFinish={onFinish}>
      <div className={styles.formItem}>
        <FormItem
          name="workId"
          rules={[{ required: true, message: '请输入工号' }]}>
          <Input placeholder="请输入工号" />
        </FormItem>
      </div>
      <div className={styles.formItem}>
        <FormItem
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}>
          <Password placeholder="请输入密码" maxLength={20} />
        </FormItem>
      </div>
      <Button type="primary" htmlType="submit" loading={loading}>
        登 录
      </Button>
      <span
        className={styles.forget}
        onClick={() => history.push('/reset-password')}>
        忘记密码
      </span>
    </Form>
  )
}
